// extracted by mini-css-extract-plugin
module.exports = {"shops":"market-module--shops--2oWAH","item":"market-module--item--2lfls","itemImage":"market-module--itemImage--MJZkV"};